export default "__VITE_ASSET__DUzetJjO__"